import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { assetsApi } from 'core/api/assets.api';
import { setAxiosAuth, toCategoryFilterKey } from 'utils';

export interface UseGetAssetsProps {
  sortType: string;
  sortOrder: string;
  searchTxt: string;
  pickupDate: string;
  returnDate: string;
  pickupTime: string;
  returnTime: string;
  availFlag: boolean;
  selCategoryTypeIds: number[];
  selLocation: string | number;
  accessToken?: string;
  enabled?: boolean;
}

export const useGetAssets = ({
  sortType,
  sortOrder,
  searchTxt,
  pickupDate,
  returnDate,
  pickupTime,
  returnTime,
  availFlag,
  selCategoryTypeIds,
  selLocation,
  accessToken = '',
  enabled = true,
}: UseGetAssetsProps) => {
  setAxiosAuth(accessToken);

  const categoryFilterKey = toCategoryFilterKey(selCategoryTypeIds);
  const locationKey =
    selLocation != null && typeof selLocation === 'object'
      ? String((selLocation as { value?: unknown }).value ?? '')
      : String(selLocation ?? '');

  return useQuery({
    queryKey: [
      queryKeys.assets,
      sortType,
      sortOrder,
      searchTxt,
      pickupDate,
      returnDate,
      pickupTime,
      returnTime,
      availFlag,
      categoryFilterKey,
      locationKey,
    ],
    queryFn: async () => await assetsApi.getAssetsOptions(
      { sortType, sortOrder },
      searchTxt,
      pickupDate,
      returnDate,
      pickupTime,
      returnTime,
      availFlag,
      selCategoryTypeIds,
      selLocation
    ),
    staleTime: 1000 * 60 * 1,
    enabled: Boolean(accessToken) && enabled,
  });
}
